import { render, staticRenderFns } from "./BusinessFederalReports.vue?vue&type=template&id=4e800c16&"
import script from "./BusinessFederalReports.vue?vue&type=script&lang=ts&"
export * from "./BusinessFederalReports.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessFederalReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports